import { IDictionary } from '../dictionary/IDictionary';
import { ICellularDeviceActivationViewModel } from './icellular-device-activation.model';

export class BaseDeviceActivation {
    protected cellularDeviceActivationViewModel: ICellularDeviceActivationViewModel = {
        deviceIdentifierMap: {},
        jobNumber: null,
        locationId: null,
        moduleId: null,
        selectedCarrier: null,
        selectedVendor: null,
    };

    protected jobNumber: number;
    protected locationId: number;
    protected moduleId: number;
    protected allowedMobileIdTypes: CASLink.Device.Ui.ViewModel.Modules.MobileIdTypeViewModel[];
    protected vendor: CASLink.Device.Ui.ViewModel.Modules.CellularVendorViewModel;
    protected carrier: CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel;
    protected canRequestActivation: boolean;
    protected deviceIdentifierMap: IDictionary<string>;

    /**
     * All device identifiers entered in the device selector are maintained in the deviceIdentifierMap in case the user,
     * for example, enters a SIM on one carrier and then swaps to another carrier with a SIM, so they won't have to retype it.
     * The MobileIdTypes that are relevant to the currently selected carrier will be passed in, so we can use that to filter --
     * this allows activations to be checked & saved for ONLY the currently selected carrier's MobileIdTypes
     */
    protected filterIrrelevantDeviceIdentifiers(deviceIdentifierMap: IDictionary<string>) {
        const filteredIdentifierMap: IDictionary<string> = {};

        this.allowedMobileIdTypes?.forEach((mobileIdType: CASLink.Device.Ui.ViewModel.Modules.MobileIdTypeViewModel) => {
            const id = mobileIdType.id;

            if (deviceIdentifierMap[id]) {
                filteredIdentifierMap[id] = deviceIdentifierMap[id];
            }
        });

        return filteredIdentifierMap;
    }

    protected prepareRequest() {
        this.cellularDeviceActivationViewModel.deviceIdentifierMap = this.filterIrrelevantDeviceIdentifiers(this.deviceIdentifierMap);
        this.cellularDeviceActivationViewModel.locationId = this.locationId;
        this.cellularDeviceActivationViewModel.moduleId = this.moduleId;
        this.cellularDeviceActivationViewModel.jobNumber = this.jobNumber;
        this.cellularDeviceActivationViewModel.selectedVendor = this.vendor;
        this.cellularDeviceActivationViewModel.selectedCarrier = this.carrier;
    }
}
